import { useState, useEffect, useContext } from 'react';
import { FetchContext } from '@src/scenario-editor/providers/fetch.context';
export type { FetchAllMessagesPayload } from '@src/scenario-editor/providers/fetch.context';

export const useFetchMessages = () => {
  const [allMessages, setAllMessages] = useState<{ message: string, scenarioId: string}[]>([]);
  const [isLoading, setIsLoading] = useState<null | boolean>(null);
  const fetchContext = useContext(FetchContext);

  if (!fetchContext) {
    throw new Error('FetchContext is not provided');
  }

  useEffect(() => {
    const fetchAllMessages = async () => {
      try {
        setIsLoading(true);
        const allMessages = await fetchContext.fetchAllMessages();

        // *INFO: Remove duplicates based on message field
        setAllMessages(
          Array.from(
            new Map(allMessages.data.map(item => [item.message, item]))
            .values()
          )
        );
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    };
    fetchAllMessages().catch(console.error);
  }, [fetchContext]);

  return [allMessages, isLoading];
};
